module.exports = {
      id: "share-linkedin-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#share-linkedin",
      toString: function () {
        return this.url;
      }
    }